import { useEffect, useState } from "react";
import BASE_URL from "../services/api";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Analytics() {
  const [users, setUsers] = useState(0);
  const [totalDonations, setTotalDonations] = useState(0);

  // ✅ FETCH ADMIN ANALYTICS (Single API)
  useEffect(() => {
    fetch(`${BASE_URL}/admin/analytics`)
      .then(res => res.json())
      .then(data => {
        setUsers(data.total_registered_users || 0);
        setTotalDonations(data.total_amount_collected || 0);
      })
      .catch(() => {
        console.log("Failed to load analytics");
      });
  }, []);

  const data = {
  labels: ["Users", "Donations (in Thousands ₹)"],
  datasets: [
    {
      label: "Platform Stats",
      data: [users, totalDonations / 1000],
      backgroundColor: "#4e6d24",
      hoverBackgroundColor: "#6f8f34",
      borderRadius: 8,
      barThickness: 50
    }
  ]
};

  const options = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false
    },
    plugins: {
      legend: {
        labels: { color: "#2f4f1f" }
      },
      tooltip: {
        backgroundColor: "#4e6d24",
        titleColor: "#ffffff",
        bodyColor: "#ffffff",
        borderColor: "#2f4f1f",
        borderWidth: 1
      }
    },
    scales: {
      x: {
        ticks: { color: "#2f4f1f" },
        grid: { color: "rgba(0,0,0,0.08)" }
      },
      y: {
        ticks: { color: "#2f4f1f" },
        grid: { color: "rgba(0,0,0,0.08)" }
      }
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="page-content">
        <div className="analytics-container">

          <h2 className="analytics-title">Analytics</h2>

          {/* TOP CARDS */}
          <div className="analytics-grid">
            <div className="analytics-card">
              <h3>Total Registered Users</h3>
              <p className="analytics-number">{users}</p>
            </div>

            <div className="analytics-card">
              <h3>Total Donations Received</h3>
              <p className="analytics-number">₹{totalDonations}</p>
            </div>
          </div>

          {/* GRAPH */}
          <div className="analytics-graph">
            <h3>Platform Overview</h3>
            <Bar data={data} options={options} />
          </div>

        </div>
      </div>
    </div>
  );
}

export default Analytics;
